import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import ButtonIcon from '../ButtonIcon';
import CustomIcon from '../CustomIcon';
import Label from '../Label';
import Markdown from '../Markdown';
import Select from '../Select';
import Span from '../Span';
import { Context } from '../../Wizard/WizardWrapper';

const SPAN_DEFAULT = '';
const MARGIN_TOP_CLASS = 'mt-5';

const SelectRenderer = ({ item, index, errors, fieldsValidated }) => {
  const { setValue } = useContext(Context);

  const htmlSelectOptions = item.selectOption.data.attributes.name;
  const divClassName =
    item.label !== null && item.label.length > 100 ? 'col-lg-12' : 'col-lg-6';
  const labelClassName =
    item.label !== null && item.label.length > 100 ? 'mb-3' : '';

  return (
    <React.Fragment key={`elements-select-${index}`}>
      <div className={`${divClassName} ${MARGIN_TOP_CLASS}`}>
        <div className="form-group">
          <Label
            className={labelClassName}
            label={item.label}
            name={item.name}
            errors={errors}
            required={item.required}
          />{' '}
          {!item.required ? (
            <ButtonIcon
              bootstrapIcon="bi-arrow-counterclockwise"
              backgroundColor="bg-success"
              handleClick={() => {
                setValue(item.name, '');
              }}
              handleKeyPress={() => {
                setValue(item.name, '');
              }}
              tooltipText="Reset field"
            />
          ) : null}
          <CustomIcon
            fieldsValidated={fieldsValidated}
            fieldError={errors[item.name]}
            required={item.required}
          />
          <Select options={htmlSelectOptions} name={item.name} />
          <Span
            text={
              errors[item.name] ? errors[item.name].message : SPAN_DEFAULT
            }
          />
        </div>

        <Markdown
          className="col-xl-12 col-lg-12 mt-3"
          text={item.description}
        />
      </div>
    </React.Fragment>
  );
};

SelectRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.object.isRequired,
  fieldsValidated: PropTypes.bool,
};

export default SelectRenderer;
